import { useEffect, useMemo, useState } from "react";
import api from "../services/axiosInstance";
import { backendPort } from "../components/Fungsiku";
import { useNotification } from "./NotifPopup";
import { LaporanKhususRow } from "./Page33_LaporanKhusus";

const getReportMemState = () => {
  if (typeof window === "undefined") return {};
  const raw = window.__laporan_runtime_state;
  if (!raw || typeof raw !== "object") return {};
  return raw;
};

const opsiLaporanEventBan = [
  {
  opsi          : "SEMUA JENIS EVENT",
  parameter     : ""
  },
  {
  opsi          : "PEMBELIAN BAN",
  parameter     : "pembelian_ban" 
  },
  {
  opsi          : "BAN BAWAAN MT BARU",
  parameter     : "ban_bawaan_mt_baru" 
  },
  {
  opsi          : "VULKANISIR",
  parameter     : "vulkanisir" 
  },
  {
  opsi          : "ROTASI BAN",
  parameter     : "rotasi" 
  },
  {
  opsi          : "LEPAS BAN",
  parameter     : "lepas" 
  },
  {
  opsi          : "PASANG BAN",
  parameter     : "pasang" 
  },
  {
  opsi          : "UBAH STATUS",
  parameter     : "ubah_status" 
  },
  {
  opsi          : "UBAH SERI BAN",
  parameter     : "ubah_seriban" 
  },
  {
  opsi          : "PENGIRIMAN KE PABRIK",
  parameter     : "kirim_ke_pabrik" 
  },
  {
  opsi          : "PINDAH GUDANG",
  parameter     : "pindah_gudang" 
  },
  {
  opsi          : "STORING",
  parameter     : "storing" 
  },
  {
  opsi          : "TAMBAL",
  parameter     : "tambal" 
  }
];

const opsiLaporanEventMT = [
  {
  opsi          : "SEMUA JENIS EVENT",
  parameter     : ""
  },
  {
  opsi          : "MT Baru, Aktivasi dan Hapus",
  parameter     : "aktivasi_mt"
  },
  {
  opsi          : "Mutasi MT antar Cabang",
  parameter     : "mutasi"
  },
  {
  opsi          : "Perubahan Profil MT",
  parameter     : "edit_profil_mt"
  },
  {
  opsi          : "Penggantian Ban",
  parameter     : "ganti_ban"
  },
  {
  opsi          : "Rotasi Ban",
  parameter     : "rotasi"
  },
  {
  opsi          : "Penggantian ODO METER (ganti/refresh/koreksi)",
  parameter     : "ganti_odo"
  },
  {
  opsi          : "Perubahan Nopol",
  parameter     : "ubah_nopol"
  },
  {
  opsi          : "Storing Event",
  parameter     : "storing"
  },
  {
  opsi          : "Repair/Tambal Ban",
  parameter     : "tambal"
  }
];

const opsiLaporanHarian = [
  {
    opsi: "Laporan Harian Lengkap",
    parameter: "laporan_lengkap",
    mode: "single",
  },
  {
    opsi: "Laporan Update ODO",
    parameter: "update_odo",
    mode: "range",
  },
  {
    opsi: "Laporan Inspeksi",
    parameter: "inspeksi",
    mode: "range",
  },
  {
    opsi: "Laporan Aktivasi MT",
    parameter: "aktivasi_mt",
    mode: "range",
  },
  {
    opsi: "Laporan Disposal",
    parameter: "disposal",
    mode: "range",
  },
  {
    opsi: "Laporan Gudang",
    parameter: "gudang",
    mode: "single",
  },
  {
    opsi: "Laporan MT Baru",
    parameter: "mt_baru",
    mode: "range",
  },
  {
    opsi: "Laporan Mutasi",
    parameter: "mutasi",
    mode: "range",
  },
  {
    opsi: "Laporan OTF",
    parameter: "otf",
    mode: "single",
  },
  {
    opsi: "Laporan OTF Afkir dan Non Aktif",
    parameter: "otf_afkir",
    mode: "single",
  },
  {
    opsi: "Laporan Pabrik",
    parameter: "pabrik",
    mode: "single",
  },
  {
    opsi: "Laporan Pelepasan",
    parameter: "pelepasan",
    mode: "range",
  },
  {
    opsi: "Laporan Pemakaian",
    parameter: "pemakaian",
    mode: "range",
  },
  {
    opsi: "Laporan Rekap WO",
    parameter: "rekap_wo",
    mode: "range",
  },
  {
    opsi: "Laporan Ubah Nopol",
    parameter: "ubah_nopol",
    mode: "range",
  },
  {
    opsi: "Laporan Ubah Seri",
    parameter: "ubah_seri",
    mode: "range",
  },
  {
    opsi: "Laporan Ubah Status",
    parameter: "ubah_status",
    mode: "range",
  },
];

const opsiWearRate = [
  {
    opsi: "Wear-rate (WR) sejak awal pengadaan",
    parameter: "sejak_awal_pengadaan",
    available: true,
  },
  {
    opsi: "Wear-rate (WR) ban OTF last_position",
    parameter: "otf_last_position",
    available: true,
  },
  {
    opsi: "Wear-rate (WR) per posisi MT",
    parameter: "per_mt_posisi",
    available: true,
  },
];

const REPORT_LOAD_TIMEOUT_MS = 210000;

const opsiCekValidasiOdoKmt = [
  {
    opsi: "Validitas ODO",
    parameter: "validitas_odo",
  },
  {
    opsi: "Validitas KM Tempuh Ban",
    parameter: "validitas_kmt_ban",
  },
];

const setReportMemState = (next) => {
  if (typeof window === "undefined") return;
  const prev = getReportMemState();
  window.__laporan_runtime_state = {
    ...prev,
    ...(next && typeof next === "object" ? next : {}),
  };
};

const PANEL_BOX_STYLE = {
  background: "linear-gradient(180deg, #f8fbff 0%, #f3f6fb 100%)",
  border: "1px solid #d8e0ee",
  boxShadow: "0 8px 24px rgba(15, 23, 42, 0.08)",
};

const PANEL_BUTTON_STYLE = {
  background: "#0f2d5c",
  color: "#ffffff",
  border: "1px solid #0f2d5c",
  boxShadow: "0 4px 12px rgba(15, 45, 92, 0.28)",
};

const PANEL_BUTTON_CLASS = "multiBaris col-md-2 px-2 py-2 rounded text-xs font-medium";

const JAKARTA_DATE_PARTS_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Jakarta",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

const JAKARTA_MONTH_PARTS_FORMATTER = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Asia/Jakarta",
  year: "numeric",
  month: "2-digit",
});

const getJakartaDateParts = (date = new Date()) => {
  const parts = JAKARTA_DATE_PARTS_FORMATTER.formatToParts(date);
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return {
    year: String(lookup.year || "").padStart(4, "0"),
    month: String(lookup.month || "").padStart(2, "0"),
    day: String(lookup.day || "").padStart(2, "0"),
  };
};

const getJakartaTodayIso = (date = new Date()) => {
  const { year, month, day } = getJakartaDateParts(date);
  return `${year}-${month}-${day}`;
};

const getJakartaYesterdayIso = (date = new Date()) => {
  const { year, month, day } = getJakartaDateParts(date);
  const yesterday = new Date(Date.UTC(Number(year), Number(month) - 1, Number(day)) - (24 * 60 * 60 * 1000));
  return `${yesterday.getUTCFullYear()}-${String(yesterday.getUTCMonth() + 1).padStart(2, "0")}-${String(yesterday.getUTCDate()).padStart(2, "0")}`;
};

const getJakartaMonthKey = (date = new Date()) => {
  const parts = JAKARTA_MONTH_PARTS_FORMATTER.formatToParts(date);
  const lookup = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${String(lookup.year || "").padStart(4, "0")}-${String(lookup.month || "").padStart(2, "0")}`;
};

const DEFAULT_REPORT_ROWS = [
  {
    key: "laporan_harian",
    label: "MASTER MT",
    info: "Daftar MT Aktif pada tanggal tertentu (snapshot).",
    badge: "No Data",
  },
  {
    key: "master_ban",
    label: "MASTER BAN OTF",
    info: "Daftar Ban Aktif pada tanggal tertentu (snapshot).",
    badge: "No Data",
  },
  {
    key: "input_odo_mt",
    label: "ODOMETER HARIAN",
    info: "Daftar input odo meter MT periode 1 bulan.",
    badge: "No Data",
  },
  {
    key: "laporan_harian_legacy",
    label: "LAPORAN HARIAN",
    info: "Laporan Harian berdasarkan format aplikasi lama.",
    badge: "No Data",
  },
  {
    key: "laporan_event_mt",
    label: "LAPORAN EVENT MT",
    info: "Laporan event MT berdasarkan jenis event dan periode bulanan.",
    badge: "No Data",
  },
  {
    key: "laporan_event_ban",
    label: "LAPORAN EVENT BAN",
    info: "Laporan event ban berdasarkan jenis event dan periode bulanan.",
    badge: "No Data",
  },
  {
    key: "laporan_khusus",
    label: "LAPORAN KHUSUS",
    info: "Daftar laporan khusus cabang beserta seluruh rantai tindak lanjut.",
    badge: "No Data",
  },
  {
    key: "laporan_koreksi_odo_td",
    label: "LAPORAN KOREKSI ODO/TD",
    info: "Daftar histori koreksi ODO dan TD berdasarkan periode koreksi.",
    badge: "No Data",
  },
  {
    key: "jarak_tempuh_mt",
    label: "JARAK TEMPUH MT",
    info: "Perhitungan Jarak Tempuh masing-masing MT dalam periode tertentu.",
    badge: "No Data",
  },
  {
    key: "wear_rate",
    label: "WEAR RATE",
    info: "Perhitungan Jarak Tempuh ban per mm level ke-aus-an ban (KM/mm).",
    badge: "No Data",
  },
  {
    key: "cek_validasi_odo_kmt",
    label: "CEK VALIDASI ODO/KMT",
    info: "Pengujuan validitas data odo dan kmt harian dengan range yang diijinkan = 0 s.d 2000 km.",
    badge: "No Data",
  },
  {
    key: "stok_gudang",
    label: "STOK GUDANG",
    info: "Daftar Stok Ban di gudang per tanggal laporan.",
    badge: "No Data",
  },
  {
    key: "stok_pabrik",
    label: "STOK PABRIK",
    info: "Daftar Stok Ban di pabrik per tanggal laporan.",
    badge: "No Data",
  },
  {
    key: "ban_vs_formasi",
    label: "BAN TERPASANG VS FORMASI",
    info: "Perbandingan ban terpasang pada MT terhadap formasi ban.",
    badge: "No Data",
  },
  {
    key: "profil_vs_event",
    label: "MT PROFIL VS LAST EVENT",
    info: "Pengujian kesuksesan generate data last event ke tabel profil MT.",
    badge: "No Data",
  },
  {
    key: "ban_profil_vs_last_event",
    label: "BAN PROFIL VS LAST EVENT",
    info: "Pengujian kesuksesan generate data last event ke tabel profil BAN.",
    badge: "No Data",
  },
  {
    key: "formasi_ban_janggal",
    label: "FORMASI BAN JANGGAL",
    info: "Pengujian kesesuaian formasi ban pada MT dengan opsi formasi: 6, 8, 10, 14, 16, 18, dan 22.",
    badge: "No Data",
  },
];

function LaporanMtRow({ row, open, onToggle, authIdentity = {}, opsiCabang = [], setPage }) {
  const { showNotif } = useNotification();
  const isMasterBan = row?.key === "master_ban";
  const isInputOdoMt = row?.key === "input_odo_mt";
  const isJarakTempuhMt = row?.key === "jarak_tempuh_mt";
  const isWearRate = row?.key === "wear_rate";
  const isLaporanHarian = row?.key === "laporan_harian_legacy";
  const isLaporanEventMt = row?.key === "laporan_event_mt";
  const isLaporanEventBan = row?.key === "laporan_event_ban";
  const isLaporanKoreksiOdoTd = row?.key === "laporan_koreksi_odo_td";
  const isCekValidasiOdoKmt = row?.key === "cek_validasi_odo_kmt";
  const isStokGudang = row?.key === "stok_gudang";
  const isStokPabrik = row?.key === "stok_pabrik";
  const isBanVsFormasi = row?.key === "ban_vs_formasi";
  const isProfilVsEvent = row?.key === "profil_vs_event";
  const isBanProfilVsLastEvent = row?.key === "ban_profil_vs_last_event";
  const isFormasiBanJanggal = row?.key === "formasi_ban_janggal";
  const isIntegritasDataCheckReport = isBanVsFormasi || isProfilVsEvent || isBanProfilVsLastEvent || isFormasiBanJanggal;
  const isNoDateReport = isBanVsFormasi || isProfilVsEvent || isBanProfilVsLastEvent || isFormasiBanJanggal;
  const isLolosUjiNoDataReport = isBanVsFormasi || isProfilVsEvent || isBanProfilVsLastEvent || isFormasiBanJanggal;
  const STOK_GUDANG_CACHE_VERSION = "v3";
  const STOK_PABRIK_CACHE_VERSION = "v1";
  const JARAK_TEMPUH_CACHE_VERSION = "v2";
  const WEAR_RATE_CACHE_VERSION = "v3";
  const LAPORAN_HARIAN_CACHE_VERSION = "v1";
  const LAPORAN_EVENT_MT_CACHE_VERSION = "v1";
  const LAPORAN_EVENT_BAN_CACHE_VERSION = "v1";
  const LAPORAN_KOREKSI_ODO_TD_CACHE_VERSION = "v1";
  const CEK_VALIDASI_ODO_KMT_CACHE_VERSION = "v1";
  let REPORT_CODE = "LAPORAN_MT";
  let UI_STATE_KEY = "laporan_mt";
  let GENERATE_ENDPOINT = "/api/main/generate_laporan_mt_dataset";
  if (isInputOdoMt) {
    REPORT_CODE = "INPUT_ODO_MT";
    UI_STATE_KEY = "input_odo_mt";
    GENERATE_ENDPOINT = "/api/main/generate_input_odo_mt_dataset";
  } else if (isWearRate) {
    REPORT_CODE = "WEAR_RATE";
    UI_STATE_KEY = "wear_rate";
    GENERATE_ENDPOINT = "/api/main/generate_wear_rate_dataset";
  } else if (isLaporanHarian) {
    REPORT_CODE = "LAPORAN_HARIAN";
    UI_STATE_KEY = "laporan_harian";
    GENERATE_ENDPOINT = "/api/main/generate_laporan_harian_dataset";
  } else if (isLaporanEventMt) {
    REPORT_CODE = "LAPORAN_EVENT_MT";
    UI_STATE_KEY = "laporan_event_mt";
    GENERATE_ENDPOINT = "/api/main/generate_laporan_event_mt_dataset";
  } else if (isLaporanEventBan) {
    REPORT_CODE = "LAPORAN_EVENT_BAN";
    UI_STATE_KEY = "laporan_event_ban";
    GENERATE_ENDPOINT = "/api/main/generate_laporan_event_ban_dataset";
  } else if (isLaporanKoreksiOdoTd) {
    REPORT_CODE = "LAPORAN_KOREKSI_ODO_TD";
    UI_STATE_KEY = "laporan_koreksi_odo_td";
    GENERATE_ENDPOINT = "/api/main/generate_laporan_koreksi_odo_td_dataset";
  } else if (isCekValidasiOdoKmt) {
    REPORT_CODE = "CEK_VALIDASI_ODO_KMT";
    UI_STATE_KEY = "cek_validasi_odo_kmt";
    GENERATE_ENDPOINT = "/api/main/generate_cek_validasi_odo_kmt_dataset";
  } else if (isJarakTempuhMt) {
    REPORT_CODE = "JARAK_TEMPUH_MT";
    UI_STATE_KEY = "jarak_tempuh_mt";
    GENERATE_ENDPOINT = "/api/main/generate_jarak_tempuh_mt_dataset";
  } else if (isStokGudang) {
    REPORT_CODE = "STOK_GUDANG";
    UI_STATE_KEY = "stok_gudang";
    GENERATE_ENDPOINT = "/api/main/generate_stok_gudang_dataset";
  } else if (isStokPabrik) {
    REPORT_CODE = "STOK_PABRIK";
    UI_STATE_KEY = "stok_pabrik";
    GENERATE_ENDPOINT = "/api/main/generate_stok_pabrik_dataset";
  } else if (isBanVsFormasi) {
    REPORT_CODE = "BAN_VS_FORMASI";
    UI_STATE_KEY = "ban_vs_formasi";
    GENERATE_ENDPOINT = "/api/main/generate_ban_vs_formasi_dataset";
  } else if (isProfilVsEvent) {
    REPORT_CODE = "PROFIL_VS_EVENT";
    UI_STATE_KEY = "profil_vs_event";
    GENERATE_ENDPOINT = "/api/main/generate_profil_vs_event_dataset";
  } else if (isBanProfilVsLastEvent) {
    REPORT_CODE = "BAN_PROFIL_VS_LAST_EVENT";
    UI_STATE_KEY = "ban_profil_vs_last_event";
    GENERATE_ENDPOINT = "/api/main/generate_ban_profil_vs_last_event_dataset";
  } else if (isFormasiBanJanggal) {
    REPORT_CODE = "FORMASI_BAN_JANGGAL";
    UI_STATE_KEY = "formasi_ban_janggal";
    GENERATE_ENDPOINT = "/api/main/generate_formasi_ban_janggal_dataset";
  } else if (isMasterBan) {
    REPORT_CODE = "MASTER_BAN";
    UI_STATE_KEY = "master_ban";
    GENERATE_ENDPOINT = "/api/main/generate_master_ban_dataset";
  }
  const tokenKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const isPusat = tokenKodeCabang === "C-1";
  const kodeCabangUser = tokenKodeCabang;
  const cabangOptions = useMemo(
    () => (Array.isArray(opsiCabang) ? opsiCabang : [])
      .map((x) => ({
        kode: String(x?.kode_cabang || "").trim(),
        nama: String(x?.nama_cabang || "").trim(),
      }))
      .filter((x) => Boolean(x.nama)),
    [opsiCabang]
  );
  const namaCabangUser = (
    isPusat
      ? "Pusat"
      : (
        cabangOptions.find((x) => x.kode === kodeCabangUser)?.nama || kodeCabangUser || ""
      )
  ).toString().trim();
  const defaultCabang = isPusat ? "" : kodeCabangUser;
  const now = new Date();
  const jakartaTodayIso = getJakartaTodayIso(now);
  const jakartaMonthKey = getJakartaMonthKey(now);
  const [jakartaYear, jakartaMonth] = jakartaMonthKey.split("-");
  const todayIso = jakartaTodayIso;
  const firstDayOfMonthIso = `${jakartaYear}-${jakartaMonth}-01`;
  const periodOptions = useMemo(() => {
    const bulanNama = [
      "Januari", "Februari", "Maret", "April", "Mei", "Juni",
      "Juli", "Agustus", "September", "Oktober", "November", "Desember",
    ];
    const startYear = 2025;
    const startMonth = 1;
    const endMonthKey = getJakartaMonthKey(new Date());
    const [endYearText, endMonthText] = endMonthKey.split("-");
    const endYear = Number(endYearText);
    const endMonth = Number(endMonthText);
    const out = [];
    let y = startYear;
    let m = startMonth;
    while (y < endYear || (y === endYear && m <= endMonth)) {
      out.push({
        value: `${y}-${String(m).padStart(2, "0")}`,
        label: `${bulanNama[m - 1]} ${y}`,
      });
      m += 1;
      if (m > 12) {
        m = 1;
        y += 1;
      }
    }
    return out;
  }, []);
  const defaultPeriode = jakartaMonthKey;
  const initialUi = useMemo(() => {
    const state = getReportMemState();
    return state?.ui?.[UI_STATE_KEY] || null;
  }, [UI_STATE_KEY]);
  const defaultSelectedCabang = isWearRate
    ? (isPusat ? "" : defaultCabang)
    : (isStokPabrik
    ? ""
    : (isIntegritasDataCheckReport ? "" : defaultCabang));
  const [selectedCabang, setSelectedCabang] = useState(String(initialUi?.selectedCabang || defaultSelectedCabang));
  const [opsiSuplier, setOpsiSuplier] = useState([]);
  const [selectedTanggal, setSelectedTanggal] = useState(String(initialUi?.selectedTanggal || todayIso));
  const [selectedTanggalAwal, setSelectedTanggalAwal] = useState(String(initialUi?.selectedTanggalAwal || firstDayOfMonthIso));
  const [selectedTanggalAkhir, setSelectedTanggalAkhir] = useState(String(initialUi?.selectedTanggalAkhir || todayIso));
  const [selectedPeriode, setSelectedPeriode] = useState(String(initialUi?.selectedPeriode || defaultPeriode));
  const [selectedLaporanHarian, setSelectedLaporanHarian] = useState(String(initialUi?.selectedLaporanHarian || opsiLaporanHarian?.[0]?.parameter || ""));
  const [selectedWearRate, setSelectedWearRate] = useState(String(initialUi?.selectedWearRate || opsiWearRate?.[0]?.parameter || ""));
  const [selectedLaporanEventMT, setSelectedLaporanEventMT] = useState(String(initialUi?.selectedLaporanEventMT || opsiLaporanEventMT?.[0]?.parameter || ""));
  const [selectedLaporanEventBan, setSelectedLaporanEventBan] = useState(String(initialUi?.selectedLaporanEventBan || opsiLaporanEventBan?.[0]?.parameter || ""));
  const [selectedCekValidasiOdoKmt, setSelectedCekValidasiOdoKmt] = useState(String(initialUi?.selectedCekValidasiOdoKmt || opsiCekValidasiOdoKmt?.[0]?.parameter || ""));
  const [isGenerating, setIsGenerating] = useState(false);
  const [cacheTick, setCacheTick] = useState(0);
  const selectedLaporanHarianOption = opsiLaporanHarian.find(
    (opt) => String(opt?.parameter || "") === String(selectedLaporanHarian || "")
  );
  const isSelectedLaporanHarianRange = Boolean(
    isLaporanHarian && selectedLaporanHarianOption?.mode === "range"
  );
  const selectedWearRateOption = opsiWearRate.find(
    (opt) => String(opt?.parameter || "") === String(selectedWearRate || "")
  );
  const isWearRatePerMtPosition = isWearRate && selectedWearRate === "per_mt_posisi";
  const wearRatePerMtMaxDate = getJakartaYesterdayIso(now);
  const isSelectedWearRateAvailable = Boolean(selectedWearRateOption?.available);
  const isDateRangeReport = isJarakTempuhMt || isLaporanKoreksiOdoTd || isSelectedLaporanHarianRange;

  const parsedCache = (() => {
    const state = getReportMemState();
    return state?.cacheMap && typeof state.cacheMap === "object" ? state.cacheMap : {};
  })();

  const reportIdentity = isLaporanHarian
    ? `${String(selectedLaporanHarian || "")}|${isSelectedLaporanHarianRange ? `${String(selectedTanggalAwal || "")}|${String(selectedTanggalAkhir || "")}` : String(selectedTanggal || "")}|${LAPORAN_HARIAN_CACHE_VERSION}`
    : (isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt)
    ? ((isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt)
      ? `${String(selectedPeriode || "")}|${String(isLaporanEventMt ? selectedLaporanEventMT : (isLaporanEventBan ? selectedLaporanEventBan : selectedCekValidasiOdoKmt) || "")}|${isLaporanEventMt ? LAPORAN_EVENT_MT_CACHE_VERSION : (isLaporanEventBan ? LAPORAN_EVENT_BAN_CACHE_VERSION : CEK_VALIDASI_ODO_KMT_CACHE_VERSION)}`
      : String(selectedPeriode || ""))
    : (isWearRate
      ? `${String(selectedWearRate || "")}|${String(selectedTanggal || "")}|${WEAR_RATE_CACHE_VERSION}`
    : (isDateRangeReport
      ? `${String(selectedTanggalAwal || "")}|${String(selectedTanggalAkhir || "")}|${isLaporanKoreksiOdoTd ? LAPORAN_KOREKSI_ODO_TD_CACHE_VERSION : (isWearRate ? WEAR_RATE_CACHE_VERSION : JARAK_TEMPUH_CACHE_VERSION)}`
    : ((isStokGudang || isStokPabrik)
      ? `${String(selectedTanggal || "")}|${isStokGudang ? STOK_GUDANG_CACHE_VERSION : STOK_PABRIK_CACHE_VERSION}`
      : String(selectedTanggal || ""))));
  const reportKey = `${REPORT_CODE}|${String(selectedCabang || "")}|${reportIdentity}`;
  const reportCache = parsedCache?.[reportKey] || null;

  const browserCacheStatus = useMemo(() => {
    if (!reportCache) return false;
    const hasRows = Array.isArray(reportCache?.rows);
    const totalRows = Number(reportCache?.meta?.total || 0);
    const isReady = Boolean(reportCache?.meta?.ready);
    return hasRows && isReady && totalRows > 0;
  }, [reportCache]);

  const readyRowCount = browserCacheStatus ? Number(reportCache?.meta?.total || 0) : 0;
  const isTanggalValid = isNoDateReport
    ? true
    : (isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt)
      ? Boolean(String(selectedPeriode || "").trim())
      : isWearRate
        ? (Boolean(String(selectedTanggal || "").trim())
          && (!isWearRatePerMtPosition || String(selectedTanggal || "") <= wearRatePerMtMaxDate))
        : isDateRangeReport
          ? (Boolean(String(selectedTanggalAwal || "").trim()) && Boolean(String(selectedTanggalAkhir || "").trim()))
          : Boolean(String(selectedTanggal || "").trim());
  const isLaporanEventBanValid = true;
  const isRangeValid = !isDateRangeReport || (
    String(selectedTanggalAwal || "") <= String(selectedTanggalAkhir || "")
  );
  const actionLabel = browserCacheStatus ? "Tampilkan" : "Generate";
  const isActionDisabled = !isTanggalValid || !isLaporanEventBanValid || isGenerating || (isWearRate && !isSelectedWearRateAvailable);

  useEffect(() => {
    if (!isStokPabrik) return;
    let isMounted = true;
    const loadOpsiSuplier = async () => {
      try {
        const { data } = await api.get(`${backendPort}/api/main/load_id_suplier`, { timeout: 30000 });
        const normalized = (Array.isArray(data?.rows) ? data.rows : [])
          .map((row) => (typeof row === "string"
            ? row
            : String(row?.id_suplier || row?.SUPLIER || row?.suplier || row?.supplier || "").trim()))
          .filter((x) => Boolean(x));
        if (!isMounted) return;
        setOpsiSuplier(normalized);
        if (selectedCabang && !normalized.includes(selectedCabang)) {
          setSelectedCabang("");
          persistUiState({ selectedCabang: "" });
        }
      } catch (err) {
        console.error("Gagal load_id_suplier:", err);
        if (!isMounted) return;
        setOpsiSuplier([]);
      }
    };
    loadOpsiSuplier();
    return () => {
      isMounted = false;
    };
  }, [isStokPabrik]);

  const persistUiState = (overrides = {}) => {
    const state = getReportMemState();
    const prevUi = state?.ui && typeof state.ui === "object" ? state.ui : {};
    const nextUi = {
      ...prevUi,
      [UI_STATE_KEY]: {
        selectedCabang,
        selectedTanggal,
        selectedTanggalAwal,
        selectedTanggalAkhir,
        selectedPeriode,
        selectedLaporanHarian,
        selectedWearRate,
        selectedLaporanEventMT,
        selectedLaporanEventBan,
        selectedCekValidasiOdoKmt,
        ...(overrides || {}),
      },
    };
    setReportMemState({ ui: nextUi });
  };

  useEffect(() => {
    if (!isWearRatePerMtPosition || String(selectedTanggal || "") <= wearRatePerMtMaxDate) return;
    setSelectedTanggal(wearRatePerMtMaxDate);
  }, [isWearRatePerMtPosition, selectedTanggal, wearRatePerMtMaxDate]);

  const handleGenerate = async () => {
    if (!isTanggalValid || browserCacheStatus) return;
    if (isDateRangeReport && !isRangeValid) {
      alert("Tanggal Awal tidak boleh lebih besar dari Tanggal Akhir.");
      return;
    }
    try {
      setIsGenerating(true);
      persistUiState();
      const payload = {
        kode_cabang: selectedCabang,
        ...(isNoDateReport
          ? {}
          : ((isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt)
            ? { periode: selectedPeriode }
            : (isWearRate
              ? { tanggal: selectedTanggal }
            : (isDateRangeReport
              ? { awal_periode: selectedTanggalAwal, akhir_periode: selectedTanggalAkhir }
              : { tanggal: selectedTanggal })))),
        ...(isLaporanHarian ? { laporan: selectedLaporanHarian } : {}),
        ...(isWearRate ? { laporan: selectedWearRate } : {}),
        ...(isLaporanEventMt ? { laporan: selectedLaporanEventMT } : {}),
        ...(isLaporanEventBan ? { laporan: selectedLaporanEventBan } : {}),
        ...(isCekValidasiOdoKmt ? { laporan: selectedCekValidasiOdoKmt } : {}),
      };
      const { data } = await api.post(`${backendPort}${GENERATE_ENDPOINT}`, payload, {
        timeout: REPORT_LOAD_TIMEOUT_MS,
      });
      const rows = Array.isArray(data?.rows) ? data.rows : [];
      const total = Number(data?.total || rows.length || 0);
      if (total <= 0) {
        const state = getReportMemState();
        const cacheMap = state?.cacheMap && typeof state.cacheMap === "object" ? { ...state.cacheMap } : {};
        delete cacheMap[reportKey];
        setReportMemState({ cacheMap });
        setCacheTick((x) => x + 1);
        if (isCekValidasiOdoKmt) {
          showNotif("success", "Semua data telah teruji valid");
        } else if (isLolosUjiNoDataReport) {
          showNotif("success", "LOLOS UJI UNTUK SEMUA KOLOM UJI.");
        } else {
          alert("Data tidak ditemukan untuk filter yang dipilih.");
        }
        return;
      }
      const state = getReportMemState();
      const nextMap = state?.cacheMap && typeof state.cacheMap === "object" ? { ...state.cacheMap } : {};
      nextMap[reportKey] = {
        meta: {
          report_code: REPORT_CODE,
          kode_cabang: selectedCabang,
          ...(isInputOdoMt
            ? { periode: selectedPeriode }
            : (isLaporanHarian
              ? {
                laporan: selectedLaporanHarian,
                ...(isSelectedLaporanHarianRange
                  ? { awal_periode: selectedTanggalAwal, akhir_periode: selectedTanggalAkhir }
                  : { tanggal: selectedTanggal }),
              }
            : (isLaporanEventMt
              ? { periode: selectedPeriode, laporan: selectedLaporanEventMT }
            : (isLaporanEventBan
              ? { periode: selectedPeriode, laporan: selectedLaporanEventBan }
            : (isCekValidasiOdoKmt
              ? { periode: selectedPeriode, laporan: selectedCekValidasiOdoKmt }
            : (isWearRate
              ? { tanggal: selectedTanggal, laporan: selectedWearRate }
            : (isDateRangeReport
              ? { awal_periode: selectedTanggalAwal, akhir_periode: selectedTanggalAkhir }
              : { tanggal: selectedTanggal }))))))),
          generated_at: new Date().toISOString(),
          total,
          ready: true,
        },
        rows,
      };
      setReportMemState({ cacheMap: nextMap });
      setCacheTick((x) => x + 1);
    } catch (err) {
      console.error(`Gagal generate ${REPORT_CODE}:`, err);
      alert(err?.response?.data?.message || `Gagal generate data ${row?.label || REPORT_CODE}`);
    } finally {
      setIsGenerating(false);
    }
  };

  const handleAction = async () => {
    if (!browserCacheStatus) {
      await handleGenerate();
      return;
    }
    persistUiState();
    const laporanHarianLabel = (opsiLaporanHarian.find((opt) => String(opt?.parameter || "") === String(selectedLaporanHarian || ""))?.opsi || row.label);
    const wearRateLabel = (opsiWearRate.find((opt) => String(opt?.parameter || "") === String(selectedWearRate || ""))?.opsi || row.label);
    const cekValidasiOdoKmtLabel = (opsiCekValidasiOdoKmt.find((opt) => String(opt?.parameter || "") === String(selectedCekValidasiOdoKmt || ""))?.opsi || row.label);
    setReportMemState({ viewMeta: {
      title: isLaporanHarian ? laporanHarianLabel : (isWearRate ? wearRateLabel : (isCekValidasiOdoKmt ? cekValidasiOdoKmtLabel : row.label)),
      tanggal: isNoDateReport
        ? "-"
        : ((isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt)
        ? (periodOptions.find((x) => x.value === selectedPeriode)?.label || selectedPeriode)
        : (isDateRangeReport ? `${selectedTanggalAwal} s/d ${selectedTanggalAkhir}` : selectedTanggal)),
      report_key: reportKey,
    }});
    if (typeof setPage === "function") setPage("Page34");
  };

  return (
    <div
      className="px-3 py-2 rounded"
      style={{ ...PANEL_BOX_STYLE, cursor: open ? "default" : "pointer" }}
      onClick={() => {
        if (!open) onToggle();
      }}
    >
      <div className="row col-md-12 align-items-center g-2">
        <div
          onClick={(e) => {
            e.stopPropagation();
            onToggle();
          }}
          style={{ ...PANEL_BUTTON_STYLE, cursor: "pointer" }}
          className={PANEL_BUTTON_CLASS}
        >
          {row.label}
        </div>
        <div className="col-md-8 text-gray-600">{row.info}</div>
        <div className="col-md-2 d-flex justify-content-md-end">
          {browserCacheStatus ? (
            <span className="px-2 py-1 rounded text-xs font-medium" style={{ background: "#fed7aa", color: "#7f1d1d" }}>
              {`${readyRowCount} baris`}
            </span>
          ) : (
            <span className="px-2 py-1 rounded text-xs font-medium bg-blue-100 text-blue-700">
              {row.badge}
            </span>
          )}
        </div>
      </div>

      {open && (
        <div className="row mt-3">
          <div className="col-md-12">
            <div className="row g-2">
              <div className="col-md-2">
                <label className="form-label mb-1">{isStokPabrik ? "SUPLIER" : "Cabang"}</label>
                <select
                  className="form-select form-select-sm"
                  value={selectedCabang}
                  onChange={(e) => {
                    setSelectedCabang(e.target.value);
                    persistUiState({ selectedCabang: e.target.value });
                  }}
                  disabled={isStokPabrik ? false : (isIntegritasDataCheckReport || !isPusat)}
                >
                  {isStokPabrik ? (
                    <>
                      <option value="">Semua Suplier</option>
                      {opsiSuplier.map((x) => (
                        <option key={x} value={x}>
                          {x}
                        </option>
                      ))}
                    </>
                  ) : isIntegritasDataCheckReport ? (
                    <option value="">Semua Cabang</option>
                  ) : (isPusat
                    ? (
                      <>
                        <option value="">Semua Cabang</option>
                        {cabangOptions.map((x) => {
                          if (isWearRate && !x.kode) return null;
                          return (
                            <option key={x.kode || x.nama} value={x.kode}>
                              {isLaporanKoreksiOdoTd ? `Cabang ${x.nama}` : x.nama}
                            </option>
                          );
                        })}
                      </>
                    )
                    : <option value={kodeCabangUser}>{isLaporanKoreksiOdoTd ? `Cabang ${namaCabangUser || "-"}` : (namaCabangUser || "-")}</option>)}
                </select>
              </div>
              {isLaporanEventMt && (
                <div className="col-md-3">
                  <label className="form-label mb-1">Jenis Laporan</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedLaporanEventMT}
                    onChange={(e) => {
                      setSelectedLaporanEventMT(e.target.value);
                      persistUiState({ selectedLaporanEventMT: e.target.value });
                    }}
                  >
                    {(Array.isArray(opsiLaporanEventMT) ? opsiLaporanEventMT : []).map((opt) => {
                      const value = String(opt?.parameter || "").trim();
                      const label = String(opt?.opsi || value).trim();
                      return (
                        <option key={value} value={value}>{label}</option>
                      );
                    })}
                  </select>
                </div>
              )}
              {isLaporanHarian && (
                <div className="col-md-3">
                  <label className="form-label mb-1">Jenis Laporan</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedLaporanHarian}
                    onChange={(e) => {
                      setSelectedLaporanHarian(e.target.value);
                      persistUiState({ selectedLaporanHarian: e.target.value });
                    }}
                  >
                    {opsiLaporanHarian.map((opt) => {
                      const value = String(opt?.parameter || "").trim();
                      const label = String(opt?.opsi || value).trim();
                      return (
                        <option key={value} value={value}>{label}</option>
                      );
                    })}
                  </select>
                </div>
              )}
              {isWearRate && (
                <div className="col-md-3">
                  <label className="form-label mb-1">Jenis Laporan</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedWearRate}
                    onChange={(e) => {
                      const nextWearRate = e.target.value;
                      const mustClampDate = nextWearRate === "per_mt_posisi" && String(selectedTanggal || "") > wearRatePerMtMaxDate;
                      setSelectedWearRate(nextWearRate);
                      if (mustClampDate) setSelectedTanggal(wearRatePerMtMaxDate);
                      persistUiState({
                        selectedWearRate: nextWearRate,
                        ...(mustClampDate ? { selectedTanggal: wearRatePerMtMaxDate } : {}),
                      });
                    }}
                  >
                    {opsiWearRate.map((opt) => {
                      const value = String(opt?.parameter || "").trim();
                      const label = String(opt?.opsi || value).trim();
                      return <option key={value} value={value}>{label}</option>;
                    })}
                  </select>
                </div>
              )}
              {isLaporanEventBan && (
                <div className="col-md-3">
                  <label className="form-label mb-1">Jenis Laporan</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedLaporanEventBan}
                    onChange={(e) => {
                      setSelectedLaporanEventBan(e.target.value);
                      persistUiState({ selectedLaporanEventBan: e.target.value });
                    }}
                  >
                    {(Array.isArray(opsiLaporanEventBan) ? opsiLaporanEventBan : []).map((opt) => {
                      const value = String(opt?.parameter || "").trim();
                      const label = String(opt?.opsi || value).trim();
                      return (
                        <option key={value} value={value}>{label}</option>
                      );
                    })}
                  </select>
                </div>
              )}
              {isCekValidasiOdoKmt && (
                <div className="col-md-3">
                  <label className="form-label mb-1">Jenis Laporan</label>
                  <select
                    className="form-select form-select-sm"
                    value={selectedCekValidasiOdoKmt}
                    onChange={(e) => {
                      setSelectedCekValidasiOdoKmt(e.target.value);
                      persistUiState({ selectedCekValidasiOdoKmt: e.target.value });
                    }}
                  >
                    {(Array.isArray(opsiCekValidasiOdoKmt) ? opsiCekValidasiOdoKmt : []).map((opt) => {
                      const value = String(opt?.parameter || "").trim();
                      const label = String(opt?.opsi || value).trim();
                      return (
                        <option key={value} value={value}>{label}</option>
                      );
                    })}
                  </select>
                </div>
              )}
              {!isNoDateReport && (
                <div className="col-md-2">
                  <label className="form-label mb-1">{(isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt) ? "Periode" : (isDateRangeReport ? (isLaporanKoreksiOdoTd ? "Tanggal Awal" : "Awal Periode") : (isWearRatePerMtPosition ? "Tanggal Akhir (maks. H-1)" : "Tanggal"))}</label>
                  {(isInputOdoMt || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt) ? (
                    <select
                      className="form-select form-select-sm"
                      value={selectedPeriode}
                      onChange={(e) => {
                        setSelectedPeriode(e.target.value);
                        persistUiState({ selectedPeriode: e.target.value });
                      }}
                    >
                      {periodOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  ) : isDateRangeReport ? (
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={selectedTanggalAwal}
                      onChange={(e) => {
                        setSelectedTanggalAwal(e.target.value);
                        persistUiState({ selectedTanggalAwal: e.target.value });
                      }}
                    />
                  ) : (
                    <input
                      type="date"
                      className="form-control form-control-sm"
                      value={selectedTanggal}
                      max={isWearRatePerMtPosition ? wearRatePerMtMaxDate : undefined}
                      onChange={(e) => {
                        setSelectedTanggal(e.target.value);
                        persistUiState({ selectedTanggal: e.target.value });
                      }}
                    />
                  )}
                </div>
              )}
              {!isNoDateReport && isDateRangeReport && (
                <div className="col-md-2">
                  <label className="form-label mb-1">{isLaporanKoreksiOdoTd ? "Tanggal Akhir" : "Akhir Periode"}</label>
                  <input
                    type="date"
                    className="form-control form-control-sm"
                    value={selectedTanggalAkhir}
                    onChange={(e) => {
                      setSelectedTanggalAkhir(e.target.value);
                      persistUiState({ selectedTanggalAkhir: e.target.value });
                    }}
                  />
                </div>
              )}
              <div className={`${isNoDateReport ? "col-md-10" : ((isLaporanHarian && isDateRangeReport) ? "col-md-3" : (isDateRangeReport ? "col-md-6" : ((isLaporanHarian || isWearRate || isLaporanEventMt || isLaporanEventBan || isCekValidasiOdoKmt) ? "col-md-5" : "col-md-8")))} d-flex align-items-end justify-content-end`}>
                <button
                  type="button"
                  className="btn btn-primary btn-sm"
                  disabled={isActionDisabled}
                  onClick={handleAction}
                >
                  {isWearRate && !isSelectedWearRateAvailable ? "Belum tersedia" : actionLabel}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export function PageKonten33_Laporan({ authIdentity = {}, opsiCabang = [], setPage }) {
  const tokenUserLevel = Number(authIdentity?.user_level ?? 0);
  const tokenNama = String(authIdentity?.nama || "").trim();
  const tokenKodeCabang = String(authIdentity?.kode_cabang || "").trim();
  const namaCabangFromMap = (
    tokenKodeCabang === "C-1"
      ? "Pusat"
      : (
        (Array.isArray(opsiCabang) ? opsiCabang : []).find(
          (x) => String(x?.kode_cabang || "").trim() === tokenKodeCabang
        )?.nama_cabang || tokenKodeCabang || "-"
      )
  );
  const isAdminLevel9 = tokenUserLevel === 9;
  const [activePanel, setActivePanel] = useState(() => {
    const state = getReportMemState();
    return state?.ui?.activePanel || null;
  });

  const handleSetActivePanel = (next) => {
    setActivePanel(next);
    const state = getReportMemState();
    const prevUi = state?.ui && typeof state.ui === "object" ? state.ui : {};
    setReportMemState({ ui: { ...prevUi, activePanel: next } });
  };

  return (
    <>
      <div className="col-md-12 d-flex justify-content-between">
        <div className="col-md-10">
          <h1 className="text-2xl font-semibold">LAPORAN</h1>
          <p className="text-gray-500 text-sm">{`Welcome ${tokenNama || ""}.`}</p>
        </div>
      </div>

      <section className="grid grid-cols-1">
        <div className="bg-white rounded-lg p-4 border">
          <h3 className="text-2xl font-medium">📊 GENERATE LAPORAN</h3>
          <p className="text-2s font-medium mb-4 text-red-800">{`Unit: ${namaCabangFromMap}`}</p>

          <div className="space-y-3 text-sm">
            <div className="flex items-center">
              <span className="mr-3">LAPORAN OTF</span>
              <div className="flex-grow h-px bg-gray-300"></div>
            </div>

            {DEFAULT_REPORT_ROWS.filter((row) => !["stok_gudang", "stok_pabrik", "laporan_harian_legacy", "laporan_event_mt", "laporan_event_ban", "laporan_khusus", "laporan_koreksi_odo_td", "cek_validasi_odo_kmt", "jarak_tempuh_mt", "wear_rate", "ban_vs_formasi", "profil_vs_event", "ban_profil_vs_last_event", "formasi_ban_janggal"].includes(row.key)).map((row) => {
              const open = activePanel === row.key;
              return (
                <LaporanMtRow
                  key={row.key}
                  row={row}
                  open={open}
                  onToggle={() => handleSetActivePanel(open ? null : row.key)}
                  authIdentity={authIdentity}
                  opsiCabang={opsiCabang}
                  setPage={setPage}
                />
              );
            })}

            <div className="flex items-center mt-3">
              <span className="mr-3">LAPORAN STOCK</span>
              <div className="flex-grow h-px bg-gray-300"></div>
            </div>

            {DEFAULT_REPORT_ROWS.filter((row) => {
              if (row.key === "stok_pabrik" && tokenKodeCabang !== "C-1") return false;
              return ["stok_gudang", "stok_pabrik"].includes(row.key);
            }).map((row) => {
              const open = activePanel === row.key;
              return (
                <LaporanMtRow
                  key={row.key}
                  row={row}
                  open={open}
                  onToggle={() => handleSetActivePanel(open ? null : row.key)}
                  authIdentity={authIdentity}
                  opsiCabang={opsiCabang}
                  setPage={setPage}
                />
              );
            })}

            <div className="flex items-center mt-3">
              <span className="mr-3">LAPORAN KINERJA</span>
              <div className="flex-grow h-px bg-gray-300"></div>
            </div>

            {DEFAULT_REPORT_ROWS.filter((row) => ["laporan_harian_legacy", "laporan_event_mt", "laporan_event_ban", "laporan_khusus", "laporan_koreksi_odo_td", "jarak_tempuh_mt", "wear_rate"].includes(row.key)).map((row) => {
              const open = activePanel === row.key;
              if (row.key === "laporan_khusus") {
                return (
                  <LaporanKhususRow
                    key={row.key}
                    row={row}
                    open={open}
                    onToggle={() => handleSetActivePanel(open ? null : row.key)}
                  />
                );
              }
              return (
                <LaporanMtRow
                  key={row.key}
                  row={row}
                  open={open}
                  onToggle={() => handleSetActivePanel(open ? null : row.key)}
                  authIdentity={authIdentity}
                  opsiCabang={opsiCabang}
                  setPage={setPage}
                />
              );
            })}

            <div className="flex items-center mt-3">
              <span className="mr-3">INTEGRITAS DATA</span>
              <div className="flex-grow h-px bg-gray-300"></div>
            </div>

            {DEFAULT_REPORT_ROWS.filter((row) => {
              if (["ban_vs_formasi", "formasi_ban_janggal"].includes(row.key)) return true;
              if (isAdminLevel9 && ["cek_validasi_odo_kmt", "profil_vs_event", "ban_profil_vs_last_event"].includes(row.key)) return true;
              return false;
            }).map((row) => {
              const open = activePanel === row.key;
              return (
                <LaporanMtRow
                  key={row.key}
                  row={row}
                  open={open}
                  onToggle={() => handleSetActivePanel(open ? null : row.key)}
                  authIdentity={authIdentity}
                  opsiCabang={opsiCabang}
                  setPage={setPage}
                />
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
